import React from "react";

const FlowIcon = () => (
  <svg
    width="1.33rem"
    height="1.33rem"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.08335 4.66667H2.33335C1.69169 4.66667 1.16669 4.14167 1.16669 3.5V2.33333C1.16669 1.69167 1.69169 1.16667 2.33335 1.16667H4.08335C4.72502 1.16667 5.25002 1.69167 5.25002 2.33333V3.5C5.25002 4.14167 4.72502 4.66667 4.08335 4.66667Z"
      stroke="#7E858F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1333 4.08333H10.0333C9.64831 4.08333 9.33331 3.76833 9.33331 3.38333V2.45001C9.33331 2.06501 9.64831 1.75 10.0333 1.75H12.1333C12.5183 1.75 12.8333 2.06501 12.8333 2.45001V3.38333C12.8333 3.76833 12.5183 4.08333 12.1333 4.08333Z"
      stroke="#7E858F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1333 8.45833H10.0333C9.64831 8.45833 9.33331 8.14333 9.33331 7.75833V6.82501C9.33331 6.44001 9.64831 6.125 10.0333 6.125H12.1333C12.5183 6.125 12.8333 6.44001 12.8333 6.82501V7.75833C12.8333 8.14333 12.5183 8.45833 12.1333 8.45833Z"
      stroke="#7E858F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 2.91667H9.33333"
      stroke="#7E858F"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.29169 2.91667V10.5C7.29169 11.1417 7.81669 11.6667 8.45835 11.6667H9.33335"
      stroke="#7E858F"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.29163 7.29166H9.33329"
      stroke="#7E858F"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1333 12.8333H10.0333C9.64831 12.8333 9.33331 12.5183 9.33331 12.1333V11.2C9.33331 10.815 9.64831 10.5 10.0333 10.5H12.1333C12.5183 10.5 12.8333 10.815 12.8333 11.2V12.1333C12.8333 12.5183 12.5183 12.8333 12.1333 12.8333Z"
      stroke="#7E858F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FlowIcon;
